export interface ThemeData {
  c1: string;
  c2: string;
  c3: string;
  tc1: string;
  tc2: string;
  tc3: string;
}

export const DefaultThemeData = {
  c1: "#027AFF",
  c2: "#0238ff",
  c3: "#eef8ff",
  tc1: "#333",
  tc2: "#666",
  tc3: "#999",
};
